module.exports = __webpack_public_path__ + "static/img/S.59cf60a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/S.png
// module id = EXv5
// module chunks = 0